import styled from "@emotion/styled"
import React from 'react'
import {Colors, eerieBlack} from '../../styles/colors'
import { Spacing } from '../../styles/spacing'
import { Typography } from '../../styles/typography'
import { extractCategory, extractLens, urlForNode } from '../../utils/blog/utils'
import { DayJs } from '../../utils/day'
import { SiteLink } from '../SiteLink'
import { Category, CATEGORY_SIZES } from './Categories'
import { Dot } from "./Dot"
import { Lens, LENS_SIZES } from './Lens'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
// Va gestita immagine
const StyledCard = styled.div`
  height: 422px;
  flex-basis: 342px;
  border-radius: 16px;
  background-color: white;
  overflow: hidden;
  transition: 0.1s all;
  :hover, :active {
    transform: scale(0.96);

  }
  .article-picture {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    width: 100%;
    object-fit: cover;
    height: 202px;
  }

  .article-box {
    padding: 20px;
    height: 190px;
  }

  .article-title {
    height: 120px;
    text-overflow: ellipsis;
    margin-bottom: 16px;
    overflow: hidden;
  }
`
export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow: visible;
  max-width: 342px;
  flex-shrink: 1;

  .card-number {
    width: 69px;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 220px;
    line-height: 200px;
    font-weight: 700;
    align-self: end;
    overflow: hidden;

    span {
      width: 69px;
      display: inline-block;

      font-family: 'DM Sans', sans-serif;
      font-weight: 700;
      font-size: 220px;
      line-height: 100%;
      align-items: flex-start;

      color: ${eerieBlack['800']};
    }
  }
`
const Image = ({fallBack, fimageSharp}) => {
  const image = getImage(fimageSharp)
  if(!image) return <img src={fallBack} className={"article-picture"}/>
  return <GatsbyImage image={image} className={"article-picture"}/>
}

export const ArticleCard = ({ article = {}, number, hideCategory = false }) => {
  const { tags, feature_image,feature_image_sharp, title, slug, published_at } = article
  const category = extractCategory(tags)
  const lens = extractLens(tags)
  const image = getImage(feature_image_sharp)


  return <SiteLink to={urlForNode(article)} internal name={article.title}>
    <CardWrapper>
      {!!number && <div className={'card-number'}><span>{number}</span></div>}
      <StyledCard className={'drop-shadow-100'}>
        <Image fallBack={feature_image} fimageSharp={feature_image_sharp}/>
        <div className={"article-box"}>
          <div css={[Spacing.Flex.row, Spacing.Margin.bottom_8]}>
            <Lens type={lens.ghostSlug} size={LENS_SIZES.small}/>
            {!hideCategory && <>
              <Dot css={Colors.Color.eerieBlack500}>•</Dot>
              <Category category={category.ghostSlug} size={CATEGORY_SIZES.small}/>
            </>
            }
          </div>
          <p css={[Typography.heading.h6_700]} className={'article-title'}>{title}</p>
          <span css={[Typography.label.label3_400, Colors.Color.eerieBlack500]}>{DayJs(published_at).format('HH:mm • DD MMM YYYY')}</span>
        </div>
      </StyledCard>
    </CardWrapper>
  </SiteLink>
}
